import React from 'react';
import searchIcon from './../../assets/search-icon.png';
import './Toolbar.css';

// Toolbar with tab navigation and search functionality. Tab navigation - only shown for current year data 
function Toolbar({ activeTab, setActiveTab, handleAddRow, setCurrentView, searchTerm, setSearchTerm, isOldData }) {
  return (
    <div className="toolbar">
      {!isOldData && (
        <div className="tabs">
          {['viewAll', 'newEmployees', 'previousYear'].map((tab) => (
            <button
              key={tab}
              className={`tab ${activeTab === tab ? 'active' : ''}`}
              onClick={() => setActiveTab(tab)}
            >
              {tab === 'viewAll'
                ? 'View All'
                : tab === 'newEmployees'
                ? 'Current Year Hires'
                : 'Previous Year Hires'}
            </button>
          ))}
        </div>
      )}
      <div className={`search-bar ${isOldData ? 'search-bar--no-margin' : ''}`}>
        <input
          type="text"
          placeholder="Search"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        <img src={searchIcon} alt="Search" className="search-icon" />
      </div>
    </div>
  );
}

export default Toolbar;